var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "26px",
    viewBox: "0 0 29 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flip",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,15.168 C4.49,15.168 4.479,15.168 4.47,15.167 C4.317,15.158 4.178,15.079 4.09,14.955 L0.59,9.955 C0.432,9.729 0.487,9.417 0.713,9.259 C0.938,9.099 1.251,9.155 1.41,9.381 L4.549,13.866 L8.628,9.333 C8.813,9.129 9.129,9.112 9.334,9.296 C9.54,9.481 9.556,9.797 9.372,10.003 L4.872,15.003 C4.776,15.108 4.641,15.168 4.5,15.168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9619,25.1172 C16.6939,25.1172 16.4729,24.9052 16.4629,24.6362 C16.4529,24.3592 16.6679,24.1282 16.9439,24.1172 C20.0079,24.0052 22.8449,22.7062 24.9319,20.4602 C27.0199,18.2132 28.1059,15.2882 27.9919,12.2242 C27.7599,5.8992 22.4119,0.9212 16.0989,1.1762 C12.9879,1.2902 10.1279,2.6372 8.0479,4.9652 C5.7989,7.4822 4.7169,10.9152 4.9989,14.6302 C5.0199,14.9052 4.8129,15.1452 4.5379,15.1672 C4.2659,15.1932 4.0229,14.9812 4.0019,14.7062 C3.6989,10.7172 4.8709,7.0202 7.3019,4.2992 C9.5659,1.7652 12.6759,0.3012 16.0629,0.1762 C22.9279,-0.0688 28.7389,5.3122 28.9909,12.1872 C29.1149,15.5182 27.9339,18.6982 25.6649,21.1402 C23.3959,23.5832 20.3119,24.9952 16.9809,25.1172 L16.9619,25.1172 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlip);
export default __webpack_public_path__ + "static/media/flip.09a94e1ab3cba2ba9cce86f88248bcf4.svg";
export { ForwardRef as ReactComponent };